/**
 * Versions of the legal documents a user consents to when signing up.
 *
 * Single frontend source for the consent versions sent to
 * `POST /api/auth/signup` (`privacyPolicyVersion`, `tosVersion`), which the
 * backend stores in `user_consents.privacy_notice_version` / `tos_version`.
 *
 * Keep in sync with the backend documents: `src/content/privacy-policy.md`,
 * `src/content/terms-of-service.md` (frontmatter `version`) and the versions
 * served by `GET /api/legal/privacy-policy` / `GET /api/legal/terms-of-service`
 * (`src/routes/legal.ts`, `src/services/legalDocuments.ts`). Bump these whenever a new document version ships so
 * new sign-ups record consent to the version they actually saw.
 */
export const PRIVACY_POLICY_VERSION = '1.8.0';
export const TERMS_OF_SERVICE_VERSION = '1.2.0';
